export default __webpack_public_path__ + "static/media/No lo busques mas.cb810272.jpg";